// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import CheckoutSuccessTemplate from 'components/checkout/CheckoutSuccessTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import type { ContextRouter } from 'react-router-dom';
import axios from 'lib/defaultClient';
import { track, TRACKING_EVENTS } from 'lib/tracking';
import { CartActions, OrdersActions, UserActions } from '../../store/actionCreators';

type Props = {
  cart: any,
  order: any,
  logged: any,
  subject: any,
  loading: any,
} & ContextRouter;

class CheckoutSuccessTemplateContainer extends Component<Props> {
  state = {
    initLoading: true,
    tosspayments: null,
    token: null,
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    const query = qs.parse(this.props.location.search);
    const pendingCheckoutData = localStorage.getItem('pendingCheckout');
    const { checkoutPayload, logged, timestamp, isOrderCreated } = JSON.parse(pendingCheckoutData);

    // 주문서 생성전
    if (pendingCheckoutData && !isOrderCreated) {
      await this.createOrderFromPendingCheckout();
    }

    // 주문서 생성후
    if (pendingCheckoutData && isOrderCreated) {
      // 구매 담당자 링크 받았는데 로그인된 상태 일 수도 있기 때문에 생성된 주문서는 비회원으로 조회
      const {
        data: { token },
      } = await axios.post(`/me/non-registered/orders/token`, {
        orderId: checkoutPayload._id,
        email: checkoutPayload.customer.email,
      });
      this.setState({ token });
      await OrdersActions.getOrder(checkoutPayload._id, { token });
    }

    // 토스페이먼츠 결제 완료 후 주문서 생성
    if (query.paymentKey) {
      await this.confirm(query);
    }

    this.setState({ initLoading: false });
  };

  createOrderFromPendingCheckout = async () => {
    try {
      const pendingCheckoutData = localStorage.getItem('pendingCheckout');

      if (!pendingCheckoutData) return;

      const { checkoutPayload, logged, timestamp } = JSON.parse(pendingCheckoutData);

      // 24시간 이상 된 데이터는 무시
      if (Date.now() - timestamp > 24 * 60 * 60 * 1000) {
        localStorage.removeItem('pendingCheckout');
        return;
      }

      if (logged) {
        // 로그인 상태일 때
        await CartActions.checkoutCart(checkoutPayload);
        await OrdersActions.getOrder(checkoutPayload._id);
        this.props.order.items.map(async item => {
          await CartActions.deleteItemCart(item.id);
        });
        await CartActions.getCart();
      } else {
        await CartActions.checkoutAsNonRegisteredCart(checkoutPayload);
        const {
          data: { token },
        } = await axios.post(`/me/non-registered/orders/token`, {
          orderId: checkoutPayload._id,
          email: checkoutPayload.customer.email,
        });
        this.setState({ token });
        await OrdersActions.getOrder(checkoutPayload._id, { token });
        this.props.order.items.map(async item => {
          await window.CacheBy.LocalCart.deleteItem(item.id);
        });
        await CartActions.getAsNonRegisteredCart({
          items: window.CacheBy.LocalCart.items,
        });
      }

      this.trackPurchaseCompleted();
      // 사용 완료된 데이터 제거
      localStorage.removeItem('pendingCheckout');
    } catch (error) {
      console.error('주문서 생성 중 오류:', error);
      localStorage.removeItem('pendingCheckout');
    }
  };

  trackPurchaseCompleted = () => {
    const { order } = this.props;
    if (!order || !order.items) return;

    const orderId = order._id || order.id;
    const storageKey = `purchase_tracked_${orderId}`;
    if (sessionStorage.getItem(storageKey)) return;

    const items = order.items.map(item => {
      let price = 0;
      if (item.price && item.price.sale && item.price.sale.raw) {
        price = item.price.sale.raw;
      }
      return {
        productId: item.product ? item.product.id : '',
        productTitle: item.product ? item.product.title : '',
        price,
        quantity: item.quantity,
      };
    });
    const value = order.total && order.total.amount ? order.total.amount.raw : 0;
    track(TRACKING_EVENTS.PURCHASE_COMPLETED, {
      transactionId: orderId,
      items,
      value,
    });
    sessionStorage.setItem(storageKey, 'true');
  };

  componentDidMount() {
    this.initialize();
  }

  confirm = async query => {
    const storageKey = `payment_confirmed_${query.paymentKey}`;
    if (sessionStorage.getItem(storageKey)) {
      return;
    }

    try {
      const response = await axios.post(`/me/orders/confirm`, {
        orderId: query.orderId,
        amount: query.amount,
        paymentKey: query.paymentKey,
      });

      sessionStorage.setItem(storageKey, 'true');
      this.setState({ tosspayments: response.data });
      this.props.history.replace('/checkout-success');

      if (response.status !== 200) {
        // 결제 실패 비즈니스 로직을 구현하세요.
        await this.props.history.push(
          `/checkout-fail?message=${response.data.message}&code=${response.status}`,
        );
      }
    } catch (e) {
      await this.props.history.push(`/checkout-fail?message=서버에러&code=500`);
    }
  };

  render() {
    const { initLoading, token } = this.state;
    const { order, logged } = this.props;
    if (initLoading) return <Circles color="blue" size="medium" text="Loading..." />;
    return (
      <CheckoutSuccessTemplate
        order={order}
        history={this.props.history}
        tosspayments={this.state.tosspayments}
        logged={logged}
        token={token}
      />
    );
  }
}

export default connect(
  ({ cart, user, orders, pender }: State) => ({
    cart,
    logged: !!user.user,
    order: orders.order,
    loading: pender.pending['orders/GET_ORDER'],
  }),
  () => ({}),
)(withRouter(CheckoutSuccessTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/checkout/CheckoutSuccessTemplateContainer.js